import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const Admin_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL;
console.log("BASE_URL", BASE_URL);
console.log("BASE_URL123:", process.env.REACT_APP_BASE_URL);

// Helper function to handle API responses
const handleResponse = async (response) => {
  const data = await response.json();
  return { data, status: response.status };
};

const axiosInstance = axios.create({
  baseURL: BASE_URL, // Replace with your actual base URL
  headers: {
    "Content-Type": "application/json",
  },
});

const axiosAdminInstance = axios.create({
  baseURL: Admin_BASE_URL, // Replace with your actual base URL
  headers: {
    "Content-Type": "application/json",
  },
});

export const getaxiosRequestWithToken = async (endpoint, params = {}) => {
  const token = localStorage.getItem("token");
  const response = await axiosInstance.get(endpoint, {
    params: params,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return { success: true, ...response.data };
};

export const getaxiosadminRequestWithToken = async (endpoint, params = {}) => {
  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(
      ([_, v]) => v !== undefined && v !== null && v !== ''
    )
  );
  const token = localStorage.getItem("token");
  const response = await axiosInstance.get(endpoint, {
    params: filteredParams,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return { success: true, ...response.data };
};

export const postFileWithToken = async (endpoint, formData) => {
  const token = localStorage.getItem("token");

  const response = await axiosInstance.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensure correct content type for file uploads
      Authorization: `Bearer ${token}`,
    },
  });

  return { success: true, ...response.data };
};

export const postAdminFileWithToken = async (endpoint, formData) => {
  const token = localStorage.getItem("token");

  const response = await axiosAdminInstance.post(endpoint, formData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensure correct content type for file uploads
      Authorization: `Bearer ${token}`,
    },
  });

  return { success: true, ...response.data };
};

export const postaxiosadminRequestWithToken = async (endpoint, body = {}) => {
  const token = localStorage.getItem("token");

  // Make the POST request using axios
  const response = await axiosAdminInstance.post(endpoint, body, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Pass token in headers
    },
  });

  return { success: true, ...response.data };
};

export const putaxiosadminRequestWithToken = async (endpoint, body = {}) => {
  const token = localStorage.getItem("token");

  // Make the PUT request using axios
  const response = await axiosAdminInstance.put(endpoint, body, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Pass token in headers
    },
  });

  return { success: true, ...response.data };
};

export const getaxiosRequestWithoutToken = async (endpoint, params = {}) => {
  const token = localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await axiosInstance.get(endpoint, {
    params: params,
    headers: headers,
  });
  return { success: true, data: response.data.data };
};

export const validateToken = async () => {
  const access_token = localStorage.getItem("token");
  const response = await axios.get(`${BASE_URL}/assistant_api/info`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access_token}`,
    },
  });
  return { success: true, data: response.data.data };
};

export const postaxiosRequestWithToken = async (endpoint, body = {}) => {
  const token = localStorage.getItem("token");

  // Make the POST request using axios
  const response = await axiosInstance.post(`${BASE_URL}/${endpoint}`, body, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Pass token in headers
    },
  });

  return { success: true, ...response.data };
};
export const deleteaxiosRequestWithToken = async (endpoint, id) => {
  const token = localStorage.getItem("token");

  // Make the DELETE request using axios
  const response = await axiosInstance.delete(`${BASE_URL}/${endpoint}/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Pass token in headers
    },
  });

  console.log("response", response.data);
  return { success: true, ...response.data };
};

export const postaxiosRequest = async (endpoint, body = {}) => {
  //

  const response = await axios.post(`${BASE_URL}/${endpoint}`, body, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return { success: true, data: response.data };
};
export const deleteAxiosRequestWithToken = async (endpoint, params = {}) => {
  const token = localStorage.getItem("token");

  // Use URLSearchParams to append query parameters
  const queryString = new URLSearchParams(params).toString();

  const response = await axiosInstance.post(
    `${BASE_URL}/${endpoint}?${queryString}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // Pass token in headers
      },
    }
  );

  return { success: true, data: response.data };
};

export const deletedAxiosRequestWithToken = async (endpoint, params = {}) => {
  const token = localStorage.getItem("token");

  // Use URLSearchParams to append query parameters
  const queryString = new URLSearchParams(params).toString();
  const url = queryString
    ? `${BASE_URL}/${endpoint}?${queryString}`
    : `${BASE_URL}/${endpoint}`;

  // Make the DELETE request
  const response = await axiosInstance.delete(url, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return { success: true, data: response.data };
};
export const deleteAdminAxiosRequestWithoutToken = async (
  endpoint,
  params = {}
) => {
  const token = localStorage.getItem("token");

  // Use URLSearchParams to append query parameters
  const queryString = new URLSearchParams(params).toString();

  const response = await axiosAdminInstance.delete(endpoint, {
    headers: {
      Authorization: `Bearer ${token}`, // Pass token in headers
    },
  });

  return { success: true, data: response.data };
};

export const getPatientPool = async (page, limit) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${BASE_URL}/assistant_api/fetch-medical-assigned-programs?page=${page}&limit=${limit}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getAdminAssistentsPool = async (page, limit, selectedStatus) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${Admin_BASE_URL}/assistant_api/get-all-assistants?page=${page}&status=${selectedStatus}&role=Assistant`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const FetchPatientMedicalProgram = async (page, Payload) => {
  const token = localStorage.getItem("token");
  const url = `assistant_api/get-patients-by-medical-program?page=${page}`;
  const response = await axiosInstance.post(`${BASE_URL}/${url}`, Payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // Pass token in headers
    },
  });

  return response.data;
};

export const FetchFaxes = async (page) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${BASE_URL}/assistant_api/fax-history?page=${page}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

// // GET Method WITH Authorization Token
// export const getRequestWithToken = async (endpoint, params = {}) => {
//
//   const token = localStorage.getItem('token');
//   const url = new URL(`${BASE_URL}/${endpoint}`);
//   // Add query parameters if any
//   Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
//   const response = await fetch(url, {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${token}`, // Pass token in headers
//     },
//   });
//   if (!response.ok) {
//     // If the response is not ok, parse the error message and throw it as an object
//     const errorData = await response.json();
//     const errorObj = { data: JSON.stringify(errorData) }; // Stringify the error data
//     throw errorObj;
//   }
//   return handleResponse(response);
// };

// // GET Method WITHOUT Authorization Token
// export const getRequest = async (endpoint, params = {}) => {
//   const url = new URL(`${BASE_URL}/${endpoint}`);
//   // Add query parameters if any
//   Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
//   const response = await fetch(url, {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });
//   return handleResponse(response);
// };

// // POST Method WITH Authorization Token
export const postRequestWithToken = async (endpoint, body = {}) => {
  const token = localStorage.getItem('token');

  const response = await fetch(`${BASE_URL}/${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`, // Pass token in headers
    },
    body: JSON.stringify(body),
  });

  return handleResponse(response);
};

// // POST Method WITHOUT Authorization Token
// export const postRequest = async (endpoint, body = {}) => {
//   const response = await fetch(`${BASE_URL}/${endpoint}`, {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(body),
//   });
//   return handleResponse(response);
// };

// // DELETE Method WITH Authorization Token
// export const deleteRequestWithToken = async (endpoint, token) => {
//   const response = await fetch(`${BASE_URL}/${endpoint}`, {
//     method: 'DELETE',
//     headers: {
//       'Content-Type': 'application/json',
//       'Authorization': `Bearer ${token}`, // Pass token in headers
//     },
//   });

//   return handleResponse(response);
// };

// // DELETE Method WITHOUT Authorization Token
// export const deleteRequest = async (endpoint) => {
//   const response = await fetch(`${BASE_URL}/${endpoint}`, {
//     method: 'DELETE',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//   });

//   return handleResponse(response);
// };
